<template>
  <div class="job-allowance">
    <p class="job-allowance__name">{{ $t(`allowance['${name}']`) }}</p>
    <div class="job-allowance__descriptions">
      <p
        v-for="(description, i) in descriptions"
        :key="`JobAllowance${name}Description${i}`"
        class="job-allowance__description"
      >
        {{ description }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    descriptions: {
      default: () => [],
      type: Array,
    },
    name: {
      required: true,
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
.job-allowance {
  @apply flex;
}
.job-allowance__name {
  @apply flex-shrink-0;
  width: 100px;
}
.job-allowance__description {
  @apply whitespace-pre-wrap break-words;
}

@screen desktop {
  .job-allowance__name {
    width: 120px;
  }
}
</style>
